export default __webpack_public_path__ + "static/media/warning.737693b2.svg";